import { ForgotToScanError } from './ForgotToScanError';
import { ForgotToScanForm } from './ForgotToScanForm';
import { ForgotToScanFormContainer } from './ForgotToScanFormContainer';
import { ForgotToScanHeader } from './ForgotToScanHeader';
import { ForgotToScanLanding } from './ForgotToScanLanding';
import { ForgotToScanSuccess } from './ForgotToScanSuccess';

export const ForgotToScan = {
  Header: ForgotToScanHeader,
  Landing: ForgotToScanLanding,
  FormContainer: ForgotToScanFormContainer,
  Form: ForgotToScanForm,
  Success: ForgotToScanSuccess,
  Error: ForgotToScanError,
};
